import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useRef } from 'react';

import Sidebar from 'components/Sidebar';

import FormSteps from './FormSteps';
import FormTips from './FormTips';

const TopContributorsOffersRanking = dynamic(
  () => import('components/TopContributorsOffersRanking'),
  { ssr: false }
);

const SuggestNewOfferSidebar = ({
  gaEventCategory,
  isShowingSuccessMessage = false,
  ...rest
}) => {
  const topContributorsOffersRankingRef = useRef(null);
  const suggestNewOfferSteps = useRef(null);
  const suggestNewOfferTips = useRef(null);

  return (
    <Sidebar
      refsToBeIgnoredBeforeFixing={[
        topContributorsOffersRankingRef,
        suggestNewOfferSteps,
        suggestNewOfferTips,
      ]}
      {...rest}
    >
      {isShowingSuccessMessage ? (
        <TopContributorsOffersRanking
          ref={topContributorsOffersRankingRef}
          gaEventCategory={gaEventCategory}
        />
      ) : (
        <>
          <FormSteps ref={suggestNewOfferSteps} className="mb-4" />
          <FormTips
            ref={suggestNewOfferTips}
            gaEventCategory={gaEventCategory}
          />
        </>
      )}
    </Sidebar>
  );
};

SuggestNewOfferSidebar.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  isShowingSuccessMessage: PropTypes.bool,
};

export default SuggestNewOfferSidebar;
